import { ReducerAction } from 'types/reducer';
import { DurationType, DurationValue } from 'types/Search/form';

export interface Config {
    maxDays: number;
    presetOptions: PresetOption[];
    defaultValues: DefaultValues;
    fallback: {
        durationExceeded: DurationValue;
    };
}

export enum ActiveDurationLayer {
    None,
    DurationLayer,
}

export interface PresetOption {
    value: DurationValue;
    label?: string;
}

interface DefaultValues {
    daysAmount: number;
    rangeMinAmount: number;
    rangeMaxAmount: number;
}

export interface InputState {
    selectedOption: string;
    days: string;
    min: string;
    max: string;
}

export interface InputChanges {
    hasDaysChange: boolean;
    hasMinChange: boolean;
    hasMaxChange: boolean;
    hasOptionChange: boolean;
}

export enum ErrorSection {
    Range = 'range',
    Day = 'day',
    RangeFrom = 'rangeFrom',
    RangeTo = 'rangeTo',
}

export interface DurationState {
    input: InputState;
    maxDays: number;
    errorSection?: ErrorSection;
    changes: InputChanges;
    isValid: boolean;
}

export enum DurationLayerAction {
    UpdateMaxDays = 'updateMaxDays',
    SelectCustomOption = 'selectCustomOption',
    UpdateDaysAmount = 'updateDaysAmount',
    UpdateRangeMinAmount = 'updateRangeMinAmount',
    UpdateRangeMaxAmount = 'updateRangeMaxAmount',
    MarkDaysChanged = 'markDaysChanged',
    MarkRangeMinChanged = 'markRangeMinChanged',
    MarkRangeMaxChanged = 'markRangeMaxChanged',
}

export type DurationLayerReducerAction =
    | ReducerAction<DurationLayerAction.UpdateMaxDays, number>
    | ReducerAction<DurationLayerAction.SelectCustomOption, DurationType>
    | ReducerAction<DurationLayerAction.UpdateDaysAmount, string>
    | ReducerAction<DurationLayerAction.UpdateRangeMinAmount, string>
    | ReducerAction<DurationLayerAction.UpdateRangeMaxAmount, string>
    | ReducerAction<DurationLayerAction.MarkDaysChanged, void>
    | ReducerAction<DurationLayerAction.MarkRangeMinChanged, void>
    | ReducerAction<DurationLayerAction.MarkRangeMaxChanged, void>;

export interface DurationLayerActionMap {
    updateMaxDays(maxDays: number): void;

    selectCustomOption(durationType: DurationType): void;

    updateDaysAmount(inputValue: string): void;

    updateRangeMinAmount(inputValue: string): void;

    updateRangeMaxAmount(inputValue: string): void;

    markDaysChanged(): void;

    markRangeMinChanged(): void;

    markRangeMaxChanged(): void;
}
